import React from 'react';
import { ArrowUpRightIcon, PhoneIcon } from 'lucide-react';
import { business, mapEmbedSrc } from '../data/site';
const mapsHref = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${business.address.street}, ${business.address.city}, ${business.address.state} ${business.address.zip}`)}`;
export function AboutVisit() {
  return <section className="w-full border-b border-black/10 bg-white py-14 lg:py-20" data-id="element-38" data-mp="2h1655xs5s95d">
      <div className="mx-auto max-w-shell px-5 lg:px-8" data-id="element-39" data-mp="2c5h2vmor8e5d">
        <div className="grid gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(0,440px)] lg:items-start lg:gap-14" data-id="element-40" data-mp="274tdf5g6c5d9">
          <div data-id="element-41" data-mp="2271a7fa2wwtr">
            <p className="text-[12px] font-bold uppercase tracking-[0.18em] text-brand-dark" data-id="element-42" data-mp="226rlrw4omxq6">
              About East End
            </p>
            <h2 className="mt-4 max-w-[560px] font-display text-[28px] font-extrabold leading-[1.1] tracking-[-0.02em] text-ink sm:text-[34px]" data-id="element-43" data-mp="1y6r29x2q7wc9">
              Oak Ridge auto repair built on clear communication
            </h2>

            <p className="mt-5 max-w-[620px] text-[16px] leading-relaxed text-steel/80" data-id="element-44" data-mp="1y56xjlr3q06p">
              East End Automotive Repair LLC is an Oak Ridge, Tennessee auto
              repair shop located at 274 Warehouse Rd. The East End Team helps
              drivers with diagnostics, maintenance, electrical, engine, A/C,
              alignment, transmission, and general repair.
            </p>
            <p className="mt-4 max-w-[620px] text-[16px] leading-relaxed text-steel/80" data-id="element-45" data-mp="2gvproorhu96q">
              If you need the fastest answer, call the shop during business
              hours. The team can talk through what your vehicle is doing,
              explain the next step, and help you decide whether to bring it in
              for diagnosis, maintenance, or repair.
            </p>

            <dl className="mt-8 grid gap-x-8 gap-y-5 border-t border-black/10 pt-7 sm:grid-cols-2" data-id="element-46" data-mp="2zvc0h44wozb2">
              <div data-id="element-47" data-mp="34lk4j6btbxqz">
                <dt className="text-[11px] font-bold uppercase tracking-[0.14em] text-steel/50" data-id="element-48" data-mp="34mu2lvio15xm">
                  Address
                </dt>
                <dd className="mt-1.5 text-[15px] leading-snug text-steel/85" data-id="element-49" data-mp="3efohmrphn03v">
                  {business.address.street}, {business.address.city},{' '}
                  {business.address.state} {business.address.zip}
                </dd>
              </div>
              <div data-id="element-50" data-mp="30gyd4r0c9y5h">
                <dt className="text-[11px] font-bold uppercase tracking-[0.14em] text-steel/50" data-id="element-51" data-mp="30hhx0d9juwm5">
                  Hours
                </dt>
                <dd className="mt-1.5 text-[15px] leading-snug text-steel/85" data-id="element-52" data-mp="2qsgfujr9q96l">
                  Monday – Friday, 8:00 AM – 5:00 PM
                  <br data-id="element-53" data-mp="2mro49juxbs75" />
                  Saturday – Sunday, Closed
                </dd>
              </div>
              <div data-id="element-54" data-mp="2hstajmvf4j89">
                <dt className="text-[11px] font-bold uppercase tracking-[0.14em] text-steel/50" data-id="element-55" data-mp="2htcuf94mphox">
                  Shop phone
                </dt>
                <dd className="mt-1.5 text-[15px] font-semibold text-ink" data-id="element-56" data-mp="27su4bwmh14yk">
                  <a href={business.phoneHref} className="whitespace-nowrap hover:text-brand-dark" data-id="element-57" data-mp="1xpfcs9f0q6uf">
                    {business.phone}
                  </a>
                </dd>
              </div>
              <div data-id="element-58" data-mp="27owd0bbi3sj0">
                <dt className="text-[11px] font-bold uppercase tracking-[0.14em] text-steel/50" data-id="element-59" data-mp="27liddau81xf9">
                  Text the shop
                </dt>
                <dd className="mt-1.5 text-[15px] font-semibold text-ink" data-id="element-60" data-mp="1ezp7gsdmq2o9">
                  <a href={business.smsHref} className="whitespace-nowrap hover:text-brand-dark" data-id="element-61" data-mp="1jy0j98nhin94">
                    {business.phone}
                  </a>
                </dd>
              </div>
              <div data-id="element-62" data-mp="1tpd6to292r9c">
                <dt className="text-[11px] font-bold uppercase tracking-[0.14em] text-steel/50" data-id="element-63" data-mp="1tpws9er3zxs4">
                  Email
                </dt>
                <dd className="mt-1.5 break-all text-[15px] text-steel/85" data-id="element-64" data-mp="116pscrhreah8">
                  <a href={`mailto:${business.email}`} className="hover:text-brand-dark" data-id="element-65" data-mp="32wop84kafbsr">
                    {business.email}
                  </a>
                </dd>
              </div>
              <div data-id="element-66" data-mp="3cn9ta7iqd8j2">
                <dt className="text-[11px] font-bold uppercase tracking-[0.14em] text-steel/50" data-id="element-67" data-mp="3cnt3t361wun2">
                  Website
                </dt>
                <dd className="mt-1.5 break-all text-[15px] text-steel/85" data-id="element-68" data-mp="3lmn4b4mi655w">
                  <a href={business.websiteUrl} target="_blank" rel="noreferrer" className="hover:text-brand-dark" data-id="element-69" data-mp="3hll4alkrhp2v">
                    EEAutomotiveRepair.com
                  </a>
                </dd>
              </div>
            </dl>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-70" data-mp="216jlijyns8nc">
              <a href={business.phoneHref} className="inline-flex items-center justify-center gap-3 whitespace-nowrap rounded-md bg-brand px-6 py-3.5 font-display text-[17px] font-bold text-white transition-colors duration-150 ease-out hover:bg-brand-light" data-id="element-71" data-mp="1w8rr9jajkafz">
                <PhoneIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-72" data-mp="2162wf5a5zvo" />
                Call {business.phone}
              </a>
              <a href={mapsHref} target="_blank" rel="noreferrer" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-ink/20 px-6 py-3.5 text-[15px] font-semibold text-ink transition-colors duration-150 ease-out hover:border-ink" data-id="element-73" data-mp="6xwjr4owszi5">
                Get directions
                <ArrowUpRightIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-74" data-mp="3k6skv261ia39" />
              </a>
            </div>
          </div>

          <div className="overflow-hidden rounded-lg border border-black/10" data-id="element-75" data-mp="1idl4rqilrogb">
            <iframe title={`Map to ${business.name}`} src={mapEmbedSrc} loading="lazy" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen className="block h-[260px] w-full border-0 sm:h-[300px] lg:h-[360px]" data-id="element-76" data-mp="1gy0bbbn6q0jd" />
          </div>
        </div>
      </div>
    </section>;
}